import { Send } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/** Input row for the Maxwell panel. Submits on Enter or the send button. */
export function MaxwellComposer({
  onSend,
  disabled,
}: {
  onSend: (text: string) => void;
  disabled: boolean;
}) {
  const [text, setText] = useState("");

  const submit = () => {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setText("");
  };

  return (
    <form
      className="flex items-center gap-2 border-t border-border px-4 py-3"
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <Input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Ask Maxwell or describe a task…"
        disabled={disabled}
      />
      <Button type="submit" size="sm" disabled={disabled || !text.trim()}>
        <Send size={14} />
        <span className="sr-only">Send</span>
      </Button>
    </form>
  );
}
